export const REQ_REQUEST = 'REQ_REQUEST'
export const REQ_SUCCESS = 'REQ_SUCCESS'
export const REQ_ERROR = 'REQ_ERROR'
export const REQ_FREE_DATA = 'REQ_FREE_DATA'

export const REQ_SET_REQUESTS_LOADING_STATE = 'REQ_SET_REQUESTS_LOADING_STATE'
export const REQ_GET_CURRENT_REQUEST = 'REQ_GET_CURRENT_REQUEST'
export const REQ_SET_CURRENT_REQUEST = 'REQ_SET_CURRENT_REQUEST'
export const REQ_GET_DOC_STATUS_LIST = 'REQ_GET_DOC_STATUS_LIST'

export const REQ_CLEAR_REQUEST_LIST = 'REQ_CLEAR_REQUEST_LIST' // Очистка списка запросов на КП
export const REQ_GET_REQUEST_LIST = 'REQ_GET_REQUEST_LIST' // Получение списка запросов на КП, согласно установленному текущему фильтру
export const REQ_GET_APPOINT_LIST = 'REQ_GET_APPOINT_LIST' // Получение списка записей на приёмку-сдачу
export const REQ_APPOINT_ADD = 'REQ_APPOINT_ADD' // Добавление записи на приёмку-сдачу
export const REQ_APPOINT_CANCEL = 'REQ_APPOINT_CANCEL' // Отмена записи на приёмку-сдачу
export const REQ_CLEAR_APPOINT_LIST = 'REQ_CLEAR_APPOINT_LIST' // Очистка списка записей на приёмку/сдачу
export const REQ_SET_REQUEST_FILTER = 'REQ_SET_REQUEST_FILTER' // Установка текущего фильтра за статус запросов, входящих в список

export const REQ_CREATE_REQUEST = 'REQ_CREATE_REQUEST' // Создание нового запроса
export const REQ_CANCEL_REQUEST = 'REQ_CANCEL_REQUEST' // Отмена запроса
export const REQ_POST_REQUEST = 'REQ_POST_REQUEST' // Изменение состояния запроса
export const REQ_ADD_FILE = 'REQ_ADD_FILE' // Добавление файла к запросу
export const REQ_DEL_FILE = 'REQ_DEL_FILE' // Удаление файла из запроса
export const REQ_CHANGE_COMMENT = 'REQ_CHANGE_COMMENT' // Добавление/обновление комментария
export const REQ_DELETE_COMMENT = 'REQ_DELETE_COMMENT' // Удаление комментария

export const REQ_ADD_ROW = 'REQ_ADD_ROW' // Добавление СИ в заказ
export const REQ_UPDATE_ROW = 'REQ_UPDATE_ROW' // Изменение СИ в заказе
export const REQ_UPDATE_ROW_PLACE = 'REQ_UPDATE_ROW_PLACE' // Изменение места оказания услуги по позиции
export const REQ_DEL_ROW = 'REQ_DEL_ROW' // Удаление СИ из заказа
